<deprecated-select-dropdown
  *ngLet="selected | async as selected"
  [multiSelect]="true"
  [placeholder]="'Select...'"
  [loadable]="loadable"
  [options]="options || []"
  [filterable]="true"
  [ngModel]="selected"
  (ngModelChange)="changeSelected($event)"
  [analyticsEvents]="{ click: analyticsEvents.clicked }"
  [leftButtons]="leftButtons"
  [selectAllButton]="selectAllButton"
  [rightButtons]="rightButtons"
  [all]="getAll(selected)"
  [selectedEnabled]="selectedEnabled"
  [disabled]="disabled"
></deprecated-select-dropdown>
